// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"0e3a9015","299":"5e68fafd","308":"1840f4be","369":"cc460772","377":"ffdd49ca","392":"08c9c7de","678":"3f1ae3c5","682":"75d53771","779":"02c68407","805":"e3aa76b4"}[chunkId] + ".chunk.js";
};